import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=5ff56d3c&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff56d3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ff56d3c')) {
      api.createRecord('5ff56d3c', component.options)
    } else {
      api.reload('5ff56d3c', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=5ff56d3c&scoped=true&", function () {
      api.rerender('5ff56d3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2TEDOHbvswMfW/JS/comp/Voucher-Unit.vue"
export default component.exports